// src/App.js
import React from "react";
import './App.css';
import Sobek from "./Sobek";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginRegister from "./LoginRegister"; // لو أنك أنشأت صفحة اللوجين
import AboutUs from './AboutUs'; // ✅
import ContactUs from './ContactUs'; // ← غيّر المسار حسب مكان الملف

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Sobek />} />
          <Route path="/login" element={<LoginRegister />} />
            <Route path="/about" element={<AboutUs />} /> {/* ✅ */}
                        <Route path="/contact" element={<ContactUs />} /> {/* ✅ */}



        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
